import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

const Layout = (props) => {
    return (
        <div className="min-h-screen bg-white dark:bg-[#070b14] text-gray-900 dark:text-gray-100 font-sans transition-colors duration-500 flex flex-col relative overflow-x-hidden">
            {/* Premium Background Glows */}
            <div className="fixed top-[-10%] right-[-10%] w-[50%] h-[50%] bg-plantlix-500/5 dark:bg-plantlix-500/10 rounded-full blur-[120px] pointer-events-none z-0" />
            <div className="fixed bottom-[-10%] left-[-10%] w-[40%] h-[40%] bg-plantlix-600/5 dark:bg-plantlix-600/10 rounded-full blur-[100px] pointer-events-none z-0" />
            
            <Header {...props} />
            <main className="flex-1 w-full flex flex-col relative z-10">
                <Outlet context={props} />
            </main>
            <Footer appVersion={props.appVersion} />
        </div>
    );
};

export default Layout;
